import styled from "styled-components";
import { Button } from "react-bootstrap";

export const FormSubText = styled.p`
  font-size: 14px;
  @media (max-width: 481px) {
    font-size: 12px;
  }
`;
export const FormHeadline = styled.p`
  @media (max-width: 481px) {
    padding: 0 !important;
    font-size: 16px !important;
  }
`;
export const FormSubHeadline = styled.p`
  white-space: break-spaces;
  @media (max-width: 481px) {
    font-size: 14px;
  }
`;
export const FormInnerContainer = styled.div`
  @media (max-width: 481px) {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
`;

export const SubmitButton = styled(Button)`
  position: relative;
  background-color: ${({ $bg }) => $bg || "#e15d3a"};
  &:hover,
  &:disabled {
    background-color: ${({ $bg }) => $bg || "#e15d3a"} !important;
  }
`;

export const SocialProofLine = styled.p`
  font-size: 0.85rem;
  color: #495057;
  text-align: center;
  margin: -4px 0 12px;
`;

export const RatingBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 8px 0 4px;
  font-size: 0.85rem;
  color: #212529;
  .stars {
    color: #f5b301;
    letter-spacing: 1px;
  }
`;

export const LoaderContainer = styled.div`
  top: 0;
  bottom: 0;
  right: 12px;
  display: flex;
  position: absolute;
  align-items: center;
`;

export const SuggestionText = styled.div`
  font-size: 12px;
`;

export const EmailSuggestion = styled.div`
  font-size: 14px;
  margin-top: 4px;
`;

// Looks like a link; tapping it puts the suggested address into the field
export const SuggestionButton = styled.button`
  padding: 0;
  border: 0;
  background: none;
  font-weight: 700;
  color: #0d6efd;
  text-decoration: underline;
  word-break: break-all;
`;
